import AbstractStonecodeFileSourceModel from './AbstractStonecodeFileSourceModel';
import doc                              from '@widesk-core/decorators/doc';

@doc.urnResource('stonecode_file_source')
export default class StonecodeFileSourceModel extends AbstractStonecodeFileSourceModel {
}
